import React from "react";

import { MenuItemVariantOffer } from "@/custom-types/MenuItem";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { getDispensaryUrl } from "@/utils/dispensaryUrls";

import { Modal } from "@/components/botanic/Modal";
import SmartOfferCard from "@/components/SmartOfferCard";

type Props = {
  offers: MenuItemVariantOffer[];
  dispensarySlug?: string;
  setModalIsVisible: (isVisible: boolean) => void;
  buttonRef: React.MutableRefObject<null>;
};

const OffersModal: React.FC<Props> = ({
  offers,
  dispensarySlug,
  buttonRef,
  setModalIsVisible,
}) => {
  const countryCode = useDomainCountryCode();

  const dealLink = getDispensaryUrl({
    countryCode,
    slug: dispensarySlug || "",
    tab: "menu",
  });

  return (
    <Modal
      title="Available Offers"
      onDismissed={() => setModalIsVisible(false)}
      returnFocusRef={buttonRef}
      width={375}
    >
      <SmartOfferCard
        offers={offers}
        dealLink={dealLink}
        displayList
        gaCategory="Menu Item Details"
      />
    </Modal>
  );
};

export default OffersModal;
